import faker from 'faker';

export default Array(5)
  .fill(0)
  .map((_, index) => [faker.hacker.abbreviation(), faker.random.number({ min: 1, max: 500 })]);
